import { makeStyles } from '@mui/styles';
import FileUpload from 'apollo-react/components/FileUpload';
import Loader from 'apollo-react/components/Loader';
import Typography from 'apollo-react/components/Typography';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setImportStep } from '../../../actions/BulkImportActions';
import { ENTITY_NAMES, IMPORT_STEPS } from '../../../constants/MasterSetupConstants';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getImportEntityProp } from '../../../selectors/BulkImportSelectors';

const useStyles = makeStyles({
  modal: { minWidth: '50%' },
  errorMessage: {
    color: 'red',
    marginTop: 10,
    textAlign: 'center',
  },
});

const allowedExelTypes = ['xlsx', 'xls', 'xlsm'];

const allowedTxtTypes = ['txt'];

export const UploadImportFile = ({ selectedFiles, setSelectedFiles, entityName }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const [uploadErrorMessage, setUploadErrorMessage] = useState('');
  const isSubmissionCode = entityName === ENTITY_NAMES.SUBMISSION_CODE;

  const allowedTypes = isSubmissionCode ? allowedTxtTypes : allowedExelTypes;

  const errorMessage = isSubmissionCode
    ? 'You can import only txt files'
    : 'You can import only xlsx files';

  const isLoading = useSelector(getImportEntityProp(entityName, 'isLoading'));
  const importStep = useSelector(getImportEntityProp(entityName, 'importStep'));

  useEffect(
    () => () => {
      setUploadErrorMessage([]);
    },
    [setSelectedFiles]
  );

  const handleUpload = ([file]) => {
    setUploadErrorMessage('');
    const fileType = _.last(file.name.split('.'));

    if (!allowedTypes.includes(fileType)) {
      setUploadErrorMessage(errorMessage);
      return;
    }
    dispatch(setImportStep(IMPORT_STEPS.UPLOAD_FILE, entityName));
    setSelectedFiles([file]);
  };

  const handleDelete = () => {
    setSelectedFiles([]);
    dispatch(setImportStep(IMPORT_STEPS.INITIAL_STEP, entityName));
  };

  return (
    <div style={{ position: 'relative', height: isLoading && 135 }}>
      {!isLoading && importStep < IMPORT_STEPS.START_IMPORT && (
        <FileUpload
          maxItems={1}
          fullWidth
          value={selectedFiles}
          onFileDelete={handleDelete}
          onUpload={handleUpload}
          dropAreaLabels={{
            activeText: translateString('Drop here to upload!'),
            browseLinkText: translateString('browse').toLowerCase(),
            defaultText: translateString('Drag files here or '),
            hoverText: translateString('Click to browse'),
            maxText: translateString('You can import only one file'),
          }}
        />
      )}
      {uploadErrorMessage && (
        <Typography className={classes.errorMessage}>
          {translateString(uploadErrorMessage)}
        </Typography>
      )}
      {isLoading && <Loader isInner />}
    </div>
  );
};
